import { getErrorMessage } from '@mairistem/finances-utils';
import ActionResultType from '../../../interfaces/pieces/ActionResultType';
import BordereauActionType from '../../../interfaces/pieces/bordereaux/BordereauActionType';
import type { BaseLiquidationOptions } from '../../../interfaces/pieces/mouvements/liquidation/BaseLiquidationOptions';
import type { BordereauWithState } from '../../../interfaces/pieces/TreeRow';
import type TreeviewActionResult from '../../../interfaces/pieces/TreeviewActionResult';
import { updateBordereau } from '../../../services/piecesComptables/bordereaux/bordereaux';
import BaseLiquidationAction from '../../pieces/BaseLiquidationAction';

class BordereauMettreEnEchecAction extends BaseLiquidationAction<BordereauWithState, BordereauActionType> {
  constructor(options: BaseLiquidationOptions = null) {
    super(options);
    this.label = 'Mettre en échec';
    this.type = BordereauActionType.METTRE_EN_ECHEC;
  }

  execute = (_bordereau: BordereauWithState): TreeviewActionResult<BordereauWithState> => ({
    type: ActionResultType.MODAL,
    extraProps: {
      isSuperUser: this.isSuperUser,
      mettreEnEchecModal: {
        visible: true,
      },
    },
  });

  executeAction = (bordereau: BordereauWithState): TreeviewActionResult<BordereauWithState> => ({
    type: ActionResultType.UPDATE,
    result: new Promise((resolve, reject) => {
      updateBordereau({
        ...bordereau,
        iddX2: '',
        identifiantBordPastell: '',
      }, new URLSearchParams({ withJournaux: 'true' })).then((updatedBordereau) => {
        resolve(updatedBordereau);
      }).catch((e) => {
        reject(Error(getErrorMessage(e, 'Erreur lors de la mise en échec du bordereau')));
      });
    }),
  });
}

export default BordereauMettreEnEchecAction;
